import React from 'react';
import { Typography } from '@mui/material';
import noDataImg from 'src/img/no-data.svg';
import useStyles from './styles';
export default function NoDataPlaceholder(_ref) {
  let text = _ref.text;
  const classes = useStyles();
  const defaultText = 'No data available.';
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: noDataImg,
    width: "160",
    height: "160",
    alt: "no data image"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, text || defaultText));
}